import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FormQuestion } from '@models/company/company-register';

@Pipe({
  name: 'displayCondition',
})
export class DisplayConditionPipe implements PipeTransform {
  transform(question: FormQuestion, formValue: any): boolean {
    return question?.displayCondition ? question.displayCondition(formValue) : false;
  }
}

@NgModule({
  declarations: [DisplayConditionPipe],
  exports: [DisplayConditionPipe],
})
export class DisplayConditionPipeModule {}
